
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as passkeys454bA6w4xTiXyIfP2_5KmKZSOOlHb0M0nHZklwDNxOIMeta } from "/data/gitlab-runner/builds/vxUBjD1hN/0/spilnu/frontend/luxcasino-uk/node_modules/@spilnu/uk/modules/uk/runtime/pages/passkeys.vue?macro=true";
import { default as redirect_45assistant0vN7P8I3rkhI9Q6q_mFFSCFx0svaVXtcBTvptkdQcOoMeta } from "/data/gitlab-runner/builds/vxUBjD1hN/0/spilnu/frontend/luxcasino-uk/node_modules/@spilnu/core/modules/payment/runtime/pages/redirect-assistant.vue?macro=true";
import { default as _91txId_93kViWpgU3NLR4zl5H6_Ag01DwN9kGIpLnzliTM18flTMMeta } from "/data/gitlab-runner/builds/vxUBjD1hN/0/spilnu/frontend/luxcasino-uk/node_modules/@spilnu/core/modules/payment/runtime/pages/pending/[txId].vue?macro=true";
import { default as modalZvPIM8KAwSQEFb5LKuE8nBg4l_ETKKoN_3rPg_kllU0Meta } from "/data/gitlab-runner/builds/vxUBjD1hN/0/spilnu/frontend/luxcasino-uk/node_modules/@spilnu/core/modules/promotion/runtime/pages/preview/modal.vue?macro=true";
import { default as _91slug_93yGxbrCy4SZuy_YHYc6yjlNd8ausAOq00T0fdAcYHcMUMeta } from "/data/gitlab-runner/builds/vxUBjD1hN/0/spilnu/frontend/luxcasino-uk/node_modules/@spilnu/uk/app/pages/games/entrance/[slug].vue?macro=true";
import { default as login7TkhkyYbMoTQK5t3wwSoRJifIuIDQJwK40UYLzqVcmoMeta } from "/data/gitlab-runner/builds/vxUBjD1hN/0/spilnu/frontend/luxcasino-uk/node_modules/@spilnu/uk/app/pages/playgame/login.vue?macro=true";
import { default as _91slug_93jZO7qPS3rdHSEhPgUXe4ZDHTkl1KsVaOLq8_fqczu6IMeta } from "/data/gitlab-runner/builds/vxUBjD1hN/0/spilnu/frontend/luxcasino-uk/node_modules/@spilnu/uk/app/pages/blog/[slug].vue?macro=true";
import { default as _91token_93xMUgTePLAIdHYwBf5dziVpGhdBGuKqkneEDcQUuHFYIMeta } from "/data/gitlab-runner/builds/vxUBjD1hN/0/spilnu/frontend/luxcasino-uk/node_modules/@spilnu/uk/app/pages/reset-password/[token].vue?macro=true";
import { default as about_45usu2dh1_QWQkuAY4jzfmmHy5ZRNo1LoUH4tG61tiyL0M8Meta } from "/data/gitlab-runner/builds/vxUBjD1hN/0/spilnu/frontend/luxcasino-uk/node_modules/@spilnu/uk/app/pages/about-us.vue?macro=true";
import { default as affiliateV3RPx6_5negiBU6W1hKm862gBZYwK_e968Ixp1L8BPcMeta } from "/data/gitlab-runner/builds/vxUBjD1hN/0/spilnu/frontend/luxcasino-uk/node_modules/@spilnu/uk/app/pages/affiliate.vue?macro=true";
import { default as indexUvWP76TlIudIbiL_OGSeXZvHkBF6rqvAWpLPw3Aewo4Meta } from "/data/gitlab-runner/builds/vxUBjD1hN/0/spilnu/frontend/luxcasino-uk/node_modules/@spilnu/uk/app/pages/blog/index.vue?macro=true";
import { default as casino_45lobbyicC3lZKg_URrk_MJTXniA0fXbAeoC_N7PwspdktacUQMeta } from "/data/gitlab-runner/builds/vxUBjD1hN/0/spilnu/frontend/luxcasino-uk/app/pages/casino-lobby.vue?macro=true";
import { default as cookiepolicypDkN8NtMPzK8kaq4cJAMPUNTodvZL1EAAVpIZOlxKNUMeta } from "/data/gitlab-runner/builds/vxUBjD1hN/0/spilnu/frontend/luxcasino-uk/node_modules/@spilnu/uk/app/pages/cookiepolicy.vue?macro=true";
import { default as customer_45supportrwBRkPtWe0UoUBfzSvaxxHCArjV2ZHSYn6gJJ6obufcMeta } from "/data/gitlab-runner/builds/vxUBjD1hN/0/spilnu/frontend/luxcasino-uk/node_modules/@spilnu/uk/app/pages/customer-support.vue?macro=true";
import { default as faqsio8VnBzE6PIUDGv4X3yAulw6LOtWuILxi1vBI5EWMoMeta } from "/data/gitlab-runner/builds/vxUBjD1hN/0/spilnu/frontend/luxcasino-uk/node_modules/@spilnu/uk/app/pages/faq.vue?macro=true";
import { default as lobbyy0fL34_H0vD_u4OaHPqmyKsYzkSRtKAgO6tao5CX_lUMeta } from "/data/gitlab-runner/builds/vxUBjD1hN/0/spilnu/frontend/luxcasino-uk/node_modules/@spilnu/uk/app/pages/lobby.vue?macro=true";
import { default as indexh_7YERyPfuskECzrwHgAvILsIqwsBgAXbP2auuWBleYMeta } from "/data/gitlab-runner/builds/vxUBjD1hN/0/spilnu/frontend/luxcasino-uk/node_modules/@spilnu/uk/app/pages/playgame/index.vue?macro=true";
import { default as privacy_45policy44taDfHG_JtkUiRUyMO7chLg_G5OyaPH8NSJ_CTMMWcMeta } from "/data/gitlab-runner/builds/vxUBjD1hN/0/spilnu/frontend/luxcasino-uk/node_modules/@spilnu/uk/app/pages/privacy-policy.vue?macro=true";
import { default as safer_45gambling9o8eKnmpnNRtZm_k1ZGBoM6SPk_mOycecKIhx_mgkCIMeta } from "/data/gitlab-runner/builds/vxUBjD1hN/0/spilnu/frontend/luxcasino-uk/node_modules/@spilnu/uk/app/pages/safer-gambling.vue?macro=true";
import { default as slots_45lobby8ysJi_4lDn2CQusrlZLRyFXo47usuN3J_sfm4WkFsf0Meta } from "/data/gitlab-runner/builds/vxUBjD1hN/0/spilnu/frontend/luxcasino-uk/node_modules/@spilnu/uk/app/pages/slots-lobby.vue?macro=true";
import { default as termssKl77MSaZFSOUo64_eQadlgSQ7UhIA7S79wONE8mPi0Meta } from "/data/gitlab-runner/builds/vxUBjD1hN/0/spilnu/frontend/luxcasino-uk/node_modules/@spilnu/uk/app/pages/terms.vue?macro=true";
import { default as tv6msG0EAOGy96SkHmIKLEcmzzIUeIJ5rS5Q809CLgpAcMeta } from "/data/gitlab-runner/builds/vxUBjD1hN/0/spilnu/frontend/luxcasino-uk/node_modules/@spilnu/uk/app/pages/tv.vue?macro=true";
import { default as _91reportId_93uvYbaaazTaF7XYb_UH1M_fhSixkH1ItKXJe6spbqqPEMeta } from "/data/gitlab-runner/builds/vxUBjD1hN/0/spilnu/frontend/luxcasino-uk/node_modules/@spilnu/uk/app/pages/(users)/users/(safer-gambling)/user-report/[reportId].vue?macro=true";
import { default as check_45informationjS7CSeefm_GaFIq_siIROzJIjcB95k3Lx0o9_duE0EkMeta } from "/data/gitlab-runner/builds/vxUBjD1hN/0/spilnu/frontend/luxcasino-uk/node_modules/@spilnu/uk/app/pages/(users)/users/check-information.vue?macro=true";
import { default as deactivatedkbVaigUrHqRIa_NrxZP1eT_MolRPHMKo3tbKGhMRY5IMeta } from "/data/gitlab-runner/builds/vxUBjD1hN/0/spilnu/frontend/luxcasino-uk/node_modules/@spilnu/uk/app/pages/(users)/users/(restricted-access)/deactivated.vue?macro=true";
import { default as delete_45account1DFu02mzEGqVuJaf868X1fy1jtf0bjGzNb_piiZtJiEMeta } from "/data/gitlab-runner/builds/vxUBjD1hN/0/spilnu/frontend/luxcasino-uk/node_modules/@spilnu/uk/app/pages/(users)/users/(safer-gambling)/delete-account.vue?macro=true";
import { default as depositP1LENVF2rwuBLC9jQr39uc2nK_CsUgG5ZuJJvkUGdegMeta } from "/data/gitlab-runner/builds/vxUBjD1hN/0/spilnu/frontend/luxcasino-uk/node_modules/@spilnu/uk/app/pages/(users)/users/deposit.vue?macro=true";
import { default as edit9D8FjiLZbAEPAP4Jy_46pirpt4uRKuQVcg49IfXe2W8Meta } from "/data/gitlab-runner/builds/vxUBjD1hN/0/spilnu/frontend/luxcasino-uk/node_modules/@spilnu/uk/app/pages/(users)/users/edit.vue?macro=true";
import { default as homeVSP2uUhNyUudtPaChU7BK_UmpjAxHMGUks7iiXj2nfMMeta } from "/data/gitlab-runner/builds/vxUBjD1hN/0/spilnu/frontend/luxcasino-uk/node_modules/@spilnu/uk/app/pages/(users)/users/home.vue?macro=true";
import { default as messageszqQOG3hTY5ZE_915Uicw6_56VFJP1miQXXJK78hQgCgMeta } from "/data/gitlab-runner/builds/vxUBjD1hN/0/spilnu/frontend/luxcasino-uk/node_modules/@spilnu/uk/app/pages/(users)/users/messages.vue?macro=true";
import { default as money_45limitsvvIWnd3GloeNm34W3377Qvnftg_VkCUa5asu5Oof6A4Meta } from "/data/gitlab-runner/builds/vxUBjD1hN/0/spilnu/frontend/luxcasino-uk/node_modules/@spilnu/uk/app/pages/(users)/users/(safer-gambling)/money-limits.vue?macro=true";
import { default as my_45bonusesKQyU9f3gzBpBsWnuiIGmDIx9AZuOG2HVn0eGeeDpp_wMeta } from "/data/gitlab-runner/builds/vxUBjD1hN/0/spilnu/frontend/luxcasino-uk/node_modules/@spilnu/uk/app/pages/(users)/users/my-bonuses.vue?macro=true";
import { default as payment_45limit_45warning9ZBSe_zgdKfydRpdQsQNCLONaAtdPlXv2kF7tvy4jpIMeta } from "/data/gitlab-runner/builds/vxUBjD1hN/0/spilnu/frontend/luxcasino-uk/node_modules/@spilnu/uk/app/pages/(users)/users/payment-limit-warning.vue?macro=true";
import { default as reached_45play_45limitsfUAV9Mn7wH9sIZKuWdeehplyvinSgN1TUFg11i0jUWUMeta } from "/data/gitlab-runner/builds/vxUBjD1hN/0/spilnu/frontend/luxcasino-uk/node_modules/@spilnu/uk/app/pages/(users)/users/(restricted-access)/reached-play-limits.vue?macro=true";
import { default as reality_45checkf71006yn3AzHnh0yF8xRbYJPJjrX8icGWSHPEIjaKa4Meta } from "/data/gitlab-runner/builds/vxUBjD1hN/0/spilnu/frontend/luxcasino-uk/node_modules/@spilnu/uk/app/pages/(users)/users/(safer-gambling)/reality-check.vue?macro=true";
import { default as safer_45gamblingSV4IllodIRleOxy3v1xSyBzgT2DMM0Qbu6hKsj9kkyoMeta } from "/data/gitlab-runner/builds/vxUBjD1hN/0/spilnu/frontend/luxcasino-uk/node_modules/@spilnu/uk/app/pages/(users)/users/(safer-gambling)/safer-gambling.vue?macro=true";
import { default as saved_45gamesNQVRZn2bLpbU9buflHe0EZSIibcefqZ__2xPGVhuRH4Meta } from "/data/gitlab-runner/builds/vxUBjD1hN/0/spilnu/frontend/luxcasino-uk/node_modules/@spilnu/uk/app/pages/(users)/users/saved-games.vue?macro=true";
import { default as self_45exclusionQjv_fividJpcf4ioIpNx5knSWIFKBkB5zvb_X5RufPoMeta } from "/data/gitlab-runner/builds/vxUBjD1hN/0/spilnu/frontend/luxcasino-uk/node_modules/@spilnu/uk/app/pages/(users)/users/(safer-gambling)/self-exclusion.vue?macro=true";
import { default as sumsub_45verificationX6SIek2MCupxO_8_f1eenNE7TvSzOYV7rnjcP7nD4v0Meta } from "/data/gitlab-runner/builds/vxUBjD1hN/0/spilnu/frontend/luxcasino-uk/node_modules/@spilnu/uk/app/pages/(users)/users/sumsub-verification.vue?macro=true";
import { default as suspendedFdGaBvy0AR1D6oGVGIyGdnk0mmsCvz_aV982oHMa36YMeta } from "/data/gitlab-runner/builds/vxUBjD1hN/0/spilnu/frontend/luxcasino-uk/node_modules/@spilnu/uk/app/pages/(users)/users/(restricted-access)/suspended.vue?macro=true";
import { default as time_45outb2geIb8bP_9ZgHzgg12jPOFQIEsLwrDq0LZzMCprPGgMeta } from "/data/gitlab-runner/builds/vxUBjD1hN/0/spilnu/frontend/luxcasino-uk/node_modules/@spilnu/uk/app/pages/(users)/users/(safer-gambling)/time-out.vue?macro=true";
import { default as withdrawo6AWzlBkfWfGDDMMCqlZ6O_E7GzETJaBCip2S6LTsCsMeta } from "/data/gitlab-runner/builds/vxUBjD1hN/0/spilnu/frontend/luxcasino-uk/node_modules/@spilnu/uk/app/pages/(users)/users/withdraw.vue?macro=true";
import { default as usersyYea8y_kv1MOyokXv1ApbFiJDdwhQrk7SHT1hg1s84gMeta } from "/data/gitlab-runner/builds/vxUBjD1hN/0/spilnu/frontend/luxcasino-uk/node_modules/@spilnu/uk/app/pages/(users)/users.vue?macro=true";
import { default as winnersp76_ndRSZrz9tkfoiRnjngbR7KuA_B_bCrxH9JB80fUMeta } from "/data/gitlab-runner/builds/vxUBjD1hN/0/spilnu/frontend/luxcasino-uk/node_modules/@spilnu/uk/app/pages/winners.vue?macro=true";
import { default as indexkMZk66fnaWrDBBHzOozpdTwaCSYXfnb_9ujj9k9oJHQMeta } from "/data/gitlab-runner/builds/vxUBjD1hN/0/spilnu/frontend/luxcasino-uk/app/pages/index.vue?macro=true";
import { default as component_45stubbKUvDcwxbcDjVydyStq59Yagf63MjYUiUDtJV_bsgFIMeta } from "/data/gitlab-runner/builds/vxUBjD1hN/0/spilnu/frontend/luxcasino-uk/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubbKUvDcwxbcDjVydyStq59Yagf63MjYUiUDtJV_bsgFI } from "/data/gitlab-runner/builds/vxUBjD1hN/0/spilnu/frontend/luxcasino-uk/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "users-passkeys",
    path: "/users/passkeys",
    meta: passkeys454bA6w4xTiXyIfP2_5KmKZSOOlHb0M0nHZklwDNxOIMeta || {},
    component: () => import("/data/gitlab-runner/builds/vxUBjD1hN/0/spilnu/frontend/luxcasino-uk/node_modules/@spilnu/uk/modules/uk/runtime/pages/passkeys.vue")
  },
  {
    name: "redirect-assistant",
    path: "/payments/redirect-assistant",
    meta: redirect_45assistant0vN7P8I3rkhI9Q6q_mFFSCFx0svaVXtcBTvptkdQcOoMeta || {},
    component: () => import("/data/gitlab-runner/builds/vxUBjD1hN/0/spilnu/frontend/luxcasino-uk/node_modules/@spilnu/core/modules/payment/runtime/pages/redirect-assistant.vue")
  },
  {
    name: "payments-pending",
    path: "/payments/pending/:txId",
    meta: _91txId_93kViWpgU3NLR4zl5H6_Ag01DwN9kGIpLnzliTM18flTMMeta || {},
    component: () => import("/data/gitlab-runner/builds/vxUBjD1hN/0/spilnu/frontend/luxcasino-uk/node_modules/@spilnu/core/modules/payment/runtime/pages/pending/[txId].vue")
  },
  {
    name: "preview-promotions-modal",
    path: "/preview/promotions/modal",
    meta: modalZvPIM8KAwSQEFb5LKuE8nBg4l_ETKKoN_3rPg_kllU0Meta || {},
    component: () => import("/data/gitlab-runner/builds/vxUBjD1hN/0/spilnu/frontend/luxcasino-uk/node_modules/@spilnu/core/modules/promotion/runtime/pages/preview/modal.vue")
  },
  {
    name: "games-entrance-slug",
    path: "/games/entrance/:slug()",
    meta: { ...(_91slug_93yGxbrCy4SZuy_YHYc6yjlNd8ausAOq00T0fdAcYHcMUMeta || {}), ...{"middleware":["entrance"]} },
    alias: ["/game/:slug","/allslots/entrance/:slug"],
    component: () => import("/data/gitlab-runner/builds/vxUBjD1hN/0/spilnu/frontend/luxcasino-uk/node_modules/@spilnu/uk/app/pages/games/entrance/[slug].vue")
  },
  {
    name: "playgame-login",
    path: "/playgame/login",
    meta: { ...(login7TkhkyYbMoTQK5t3wwSoRJifIuIDQJwK40UYLzqVcmoMeta || {}), ...{"middleware":["playgame-login"]} },
    component: () => import("/data/gitlab-runner/builds/vxUBjD1hN/0/spilnu/frontend/luxcasino-uk/node_modules/@spilnu/uk/app/pages/playgame/login.vue")
  },
  {
    name: "blog-slug",
    path: "/blog/:slug()",
    meta: _91slug_93jZO7qPS3rdHSEhPgUXe4ZDHTkl1KsVaOLq8_fqczu6IMeta || {},
    component: () => import("/data/gitlab-runner/builds/vxUBjD1hN/0/spilnu/frontend/luxcasino-uk/node_modules/@spilnu/uk/app/pages/blog/[slug].vue")
  },
  {
    name: "reset-password-token",
    path: "/reset-password/:token()",
    meta: { ...(_91token_93xMUgTePLAIdHYwBf5dziVpGhdBGuKqkneEDcQUuHFYIMeta || {}), ...{"middleware":["guest-only"]} },
    component: () => import("/data/gitlab-runner/builds/vxUBjD1hN/0/spilnu/frontend/luxcasino-uk/node_modules/@spilnu/uk/app/pages/reset-password/[token].vue")
  },
  {
    name: "about-us",
    path: "/about-us",
    meta: about_45usu2dh1_QWQkuAY4jzfmmHy5ZRNo1LoUH4tG61tiyL0M8Meta || {},
    component: () => import("/data/gitlab-runner/builds/vxUBjD1hN/0/spilnu/frontend/luxcasino-uk/node_modules/@spilnu/uk/app/pages/about-us.vue")
  },
  {
    name: "affiliate",
    path: "/affiliate",
    meta: affiliateV3RPx6_5negiBU6W1hKm862gBZYwK_e968Ixp1L8BPcMeta || {},
    component: () => import("/data/gitlab-runner/builds/vxUBjD1hN/0/spilnu/frontend/luxcasino-uk/node_modules/@spilnu/uk/app/pages/affiliate.vue")
  },
  {
    name: "blog",
    path: "/blog",
    meta: indexUvWP76TlIudIbiL_OGSeXZvHkBF6rqvAWpLPw3Aewo4Meta || {},
    component: () => import("/data/gitlab-runner/builds/vxUBjD1hN/0/spilnu/frontend/luxcasino-uk/node_modules/@spilnu/uk/app/pages/blog/index.vue")
  },
  {
    name: "casino-lobby",
    path: "/casino-lobby",
    meta: casino_45lobbyicC3lZKg_URrk_MJTXniA0fXbAeoC_N7PwspdktacUQMeta || {},
    component: () => import("/data/gitlab-runner/builds/vxUBjD1hN/0/spilnu/frontend/luxcasino-uk/app/pages/casino-lobby.vue")
  },
  {
    name: "cookiepolicy",
    path: "/cookiepolicy",
    meta: cookiepolicypDkN8NtMPzK8kaq4cJAMPUNTodvZL1EAAVpIZOlxKNUMeta || {},
    component: () => import("/data/gitlab-runner/builds/vxUBjD1hN/0/spilnu/frontend/luxcasino-uk/node_modules/@spilnu/uk/app/pages/cookiepolicy.vue")
  },
  {
    name: "customer-support",
    path: "/customer-support",
    meta: customer_45supportrwBRkPtWe0UoUBfzSvaxxHCArjV2ZHSYn6gJJ6obufcMeta || {},
    component: () => import("/data/gitlab-runner/builds/vxUBjD1hN/0/spilnu/frontend/luxcasino-uk/node_modules/@spilnu/uk/app/pages/customer-support.vue")
  },
  {
    name: "faq",
    path: "/faq",
    meta: faqsio8VnBzE6PIUDGv4X3yAulw6LOtWuILxi1vBI5EWMoMeta || {},
    component: () => import("/data/gitlab-runner/builds/vxUBjD1hN/0/spilnu/frontend/luxcasino-uk/node_modules/@spilnu/uk/app/pages/faq.vue")
  },
  {
    name: "lobby",
    path: "/lobby",
    meta: { ...(lobbyy0fL34_H0vD_u4OaHPqmyKsYzkSRtKAgO6tao5CX_lUMeta || {}), ...{"middleware":["recurring-consent"]} },
    component: () => import("/data/gitlab-runner/builds/vxUBjD1hN/0/spilnu/frontend/luxcasino-uk/node_modules/@spilnu/uk/app/pages/lobby.vue")
  },
  {
    name: "playgame",
    path: "/playgame",
    meta: { ...(indexh_7YERyPfuskECzrwHgAvILsIqwsBgAXbP2auuWBleYMeta || {}), ...{"middleware":["playgame"]} },
    component: () => import("/data/gitlab-runner/builds/vxUBjD1hN/0/spilnu/frontend/luxcasino-uk/node_modules/@spilnu/uk/app/pages/playgame/index.vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: privacy_45policy44taDfHG_JtkUiRUyMO7chLg_G5OyaPH8NSJ_CTMMWcMeta || {},
    component: () => import("/data/gitlab-runner/builds/vxUBjD1hN/0/spilnu/frontend/luxcasino-uk/node_modules/@spilnu/uk/app/pages/privacy-policy.vue")
  },
  {
    name: "safer-gambling",
    path: "/safer-gambling",
    meta: safer_45gambling9o8eKnmpnNRtZm_k1ZGBoM6SPk_mOycecKIhx_mgkCIMeta || {},
    component: () => import("/data/gitlab-runner/builds/vxUBjD1hN/0/spilnu/frontend/luxcasino-uk/node_modules/@spilnu/uk/app/pages/safer-gambling.vue")
  },
  {
    name: "slots-lobby",
    path: "/slots-lobby",
    meta: slots_45lobby8ysJi_4lDn2CQusrlZLRyFXo47usuN3J_sfm4WkFsf0Meta || {},
    component: () => import("/data/gitlab-runner/builds/vxUBjD1hN/0/spilnu/frontend/luxcasino-uk/node_modules/@spilnu/uk/app/pages/slots-lobby.vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: termssKl77MSaZFSOUo64_eQadlgSQ7UhIA7S79wONE8mPi0Meta || {},
    component: () => import("/data/gitlab-runner/builds/vxUBjD1hN/0/spilnu/frontend/luxcasino-uk/node_modules/@spilnu/uk/app/pages/terms.vue")
  },
  {
    name: "tv",
    path: "/tv",
    component: () => import("/data/gitlab-runner/builds/vxUBjD1hN/0/spilnu/frontend/luxcasino-uk/node_modules/@spilnu/uk/app/pages/tv.vue")
  },
  {
    name: "users",
    path: "/users",
    meta: { ...(usersyYea8y_kv1MOyokXv1ApbFiJDdwhQrk7SHT1hg1s84gMeta || {}), ...{"groups":["users"],"middleware":["require-auth"]} },
    component: () => import("/data/gitlab-runner/builds/vxUBjD1hN/0/spilnu/frontend/luxcasino-uk/node_modules/@spilnu/uk/app/pages/(users)/users.vue"),
    children: [
  {
    name: "users-user-report-reportId",
    path: "user-report/:reportId()",
    meta: { ...(_91reportId_93uvYbaaazTaF7XYb_UH1M_fhSixkH1ItKXJe6spbqqPEMeta || {}), ...{"groups":["users","safergambling"]} },
    component: () => import("/data/gitlab-runner/builds/vxUBjD1hN/0/spilnu/frontend/luxcasino-uk/node_modules/@spilnu/uk/app/pages/(users)/users/(safer-gambling)/user-report/[reportId].vue")
  },
  {
    name: "users-check-information",
    path: "check-information",
    meta: { ...(check_45informationjS7CSeefm_GaFIq_siIROzJIjcB95k3Lx0o9_duE0EkMeta || {}), ...{"groups":["users"]} },
    component: () => import("/data/gitlab-runner/builds/vxUBjD1hN/0/spilnu/frontend/luxcasino-uk/node_modules/@spilnu/uk/app/pages/(users)/users/check-information.vue")
  },
  {
    name: "users-deactivated",
    path: "deactivated",
    meta: { ...(deactivatedkbVaigUrHqRIa_NrxZP1eT_MolRPHMKo3tbKGhMRY5IMeta || {}), ...{"groups":["users","restrictedaccess"]} },
    component: () => import("/data/gitlab-runner/builds/vxUBjD1hN/0/spilnu/frontend/luxcasino-uk/node_modules/@spilnu/uk/app/pages/(users)/users/(restricted-access)/deactivated.vue")
  },
  {
    name: "users-delete-account",
    path: "delete-account",
    meta: { ...(delete_45account1DFu02mzEGqVuJaf868X1fy1jtf0bjGzNb_piiZtJiEMeta || {}), ...{"groups":["users","safergambling"]} },
    component: () => import("/data/gitlab-runner/builds/vxUBjD1hN/0/spilnu/frontend/luxcasino-uk/node_modules/@spilnu/uk/app/pages/(users)/users/(safer-gambling)/delete-account.vue")
  },
  {
    name: "users-deposit",
    path: "deposit",
    meta: { ...(depositP1LENVF2rwuBLC9jQr39uc2nK_CsUgG5ZuJJvkUGdegMeta || {}), ...{"groups":["users"],"middleware":["clean-view-param"]} },
    component: () => import("/data/gitlab-runner/builds/vxUBjD1hN/0/spilnu/frontend/luxcasino-uk/node_modules/@spilnu/uk/app/pages/(users)/users/deposit.vue")
  },
  {
    name: "users-edit",
    path: "edit",
    meta: { ...(edit9D8FjiLZbAEPAP4Jy_46pirpt4uRKuQVcg49IfXe2W8Meta || {}), ...{"groups":["users"]} },
    component: () => import("/data/gitlab-runner/builds/vxUBjD1hN/0/spilnu/frontend/luxcasino-uk/node_modules/@spilnu/uk/app/pages/(users)/users/edit.vue")
  },
  {
    name: "users-home",
    path: "home",
    meta: { ...(homeVSP2uUhNyUudtPaChU7BK_UmpjAxHMGUks7iiXj2nfMMeta || {}), ...{"groups":["users"]} },
    component: () => import("/data/gitlab-runner/builds/vxUBjD1hN/0/spilnu/frontend/luxcasino-uk/node_modules/@spilnu/uk/app/pages/(users)/users/home.vue")
  },
  {
    name: "users-messages",
    path: "messages",
    meta: { ...(messageszqQOG3hTY5ZE_915Uicw6_56VFJP1miQXXJK78hQgCgMeta || {}), ...{"groups":["users"]} },
    component: () => import("/data/gitlab-runner/builds/vxUBjD1hN/0/spilnu/frontend/luxcasino-uk/node_modules/@spilnu/uk/app/pages/(users)/users/messages.vue")
  },
  {
    name: "users-money-limits",
    path: "money-limits",
    meta: { ...(money_45limitsvvIWnd3GloeNm34W3377Qvnftg_VkCUa5asu5Oof6A4Meta || {}), ...{"groups":["users","safergambling"]} },
    component: () => import("/data/gitlab-runner/builds/vxUBjD1hN/0/spilnu/frontend/luxcasino-uk/node_modules/@spilnu/uk/app/pages/(users)/users/(safer-gambling)/money-limits.vue")
  },
  {
    name: "users-my-bonuses",
    path: "my-bonuses",
    meta: { ...(my_45bonusesKQyU9f3gzBpBsWnuiIGmDIx9AZuOG2HVn0eGeeDpp_wMeta || {}), ...{"groups":["users"]} },
    component: () => import("/data/gitlab-runner/builds/vxUBjD1hN/0/spilnu/frontend/luxcasino-uk/node_modules/@spilnu/uk/app/pages/(users)/users/my-bonuses.vue")
  },
  {
    name: "users-payment-limit-warning",
    path: "payment-limit-warning",
    meta: { ...(payment_45limit_45warning9ZBSe_zgdKfydRpdQsQNCLONaAtdPlXv2kF7tvy4jpIMeta || {}), ...{"groups":["users"]} },
    component: () => import("/data/gitlab-runner/builds/vxUBjD1hN/0/spilnu/frontend/luxcasino-uk/node_modules/@spilnu/uk/app/pages/(users)/users/payment-limit-warning.vue")
  },
  {
    name: "users-reached-play-limits",
    path: "reached-play-limits",
    meta: { ...(reached_45play_45limitsfUAV9Mn7wH9sIZKuWdeehplyvinSgN1TUFg11i0jUWUMeta || {}), ...{"groups":["users","restrictedaccess"]} },
    component: () => import("/data/gitlab-runner/builds/vxUBjD1hN/0/spilnu/frontend/luxcasino-uk/node_modules/@spilnu/uk/app/pages/(users)/users/(restricted-access)/reached-play-limits.vue")
  },
  {
    name: "users-reality-check",
    path: "reality-check",
    meta: { ...(reality_45checkf71006yn3AzHnh0yF8xRbYJPJjrX8icGWSHPEIjaKa4Meta || {}), ...{"groups":["users","safergambling"]} },
    component: () => import("/data/gitlab-runner/builds/vxUBjD1hN/0/spilnu/frontend/luxcasino-uk/node_modules/@spilnu/uk/app/pages/(users)/users/(safer-gambling)/reality-check.vue")
  },
  {
    name: "users-safer-gambling",
    path: "safer-gambling",
    meta: { ...(safer_45gamblingSV4IllodIRleOxy3v1xSyBzgT2DMM0Qbu6hKsj9kkyoMeta || {}), ...{"groups":["users","safergambling"]} },
    component: () => import("/data/gitlab-runner/builds/vxUBjD1hN/0/spilnu/frontend/luxcasino-uk/node_modules/@spilnu/uk/app/pages/(users)/users/(safer-gambling)/safer-gambling.vue")
  },
  {
    name: "users-saved-games",
    path: "saved-games",
    meta: { ...(saved_45gamesNQVRZn2bLpbU9buflHe0EZSIibcefqZ__2xPGVhuRH4Meta || {}), ...{"groups":["users"]} },
    component: () => import("/data/gitlab-runner/builds/vxUBjD1hN/0/spilnu/frontend/luxcasino-uk/node_modules/@spilnu/uk/app/pages/(users)/users/saved-games.vue")
  },
  {
    name: "users-self-exclusion",
    path: "self-exclusion",
    meta: { ...(self_45exclusionQjv_fividJpcf4ioIpNx5knSWIFKBkB5zvb_X5RufPoMeta || {}), ...{"groups":["users","safergambling"]} },
    component: () => import("/data/gitlab-runner/builds/vxUBjD1hN/0/spilnu/frontend/luxcasino-uk/node_modules/@spilnu/uk/app/pages/(users)/users/(safer-gambling)/self-exclusion.vue")
  },
  {
    name: "users-sumsub-verification",
    path: "sumsub-verification",
    meta: { ...(sumsub_45verificationX6SIek2MCupxO_8_f1eenNE7TvSzOYV7rnjcP7nD4v0Meta || {}), ...{"groups":["users"]} },
    component: () => import("/data/gitlab-runner/builds/vxUBjD1hN/0/spilnu/frontend/luxcasino-uk/node_modules/@spilnu/uk/app/pages/(users)/users/sumsub-verification.vue")
  },
  {
    name: "users-suspended",
    path: "suspended",
    meta: { ...(suspendedFdGaBvy0AR1D6oGVGIyGdnk0mmsCvz_aV982oHMa36YMeta || {}), ...{"groups":["users","restrictedaccess"]} },
    component: () => import("/data/gitlab-runner/builds/vxUBjD1hN/0/spilnu/frontend/luxcasino-uk/node_modules/@spilnu/uk/app/pages/(users)/users/(restricted-access)/suspended.vue")
  },
  {
    name: "users-time-out",
    path: "time-out",
    meta: { ...(time_45outb2geIb8bP_9ZgHzgg12jPOFQIEsLwrDq0LZzMCprPGgMeta || {}), ...{"groups":["users","safergambling"]} },
    component: () => import("/data/gitlab-runner/builds/vxUBjD1hN/0/spilnu/frontend/luxcasino-uk/node_modules/@spilnu/uk/app/pages/(users)/users/(safer-gambling)/time-out.vue")
  },
  {
    name: "users-withdraw",
    path: "withdraw",
    meta: { ...(withdrawo6AWzlBkfWfGDDMMCqlZ6O_E7GzETJaBCip2S6LTsCsMeta || {}), ...{"groups":["users"]} },
    component: () => import("/data/gitlab-runner/builds/vxUBjD1hN/0/spilnu/frontend/luxcasino-uk/node_modules/@spilnu/uk/app/pages/(users)/users/withdraw.vue")
  }
]
  },
  {
    name: "winners",
    path: "/winners",
    meta: winnersp76_ndRSZrz9tkfoiRnjngbR7KuA_B_bCrxH9JB80fUMeta || {},
    component: () => import("/data/gitlab-runner/builds/vxUBjD1hN/0/spilnu/frontend/luxcasino-uk/node_modules/@spilnu/uk/app/pages/winners.vue")
  },
  {
    name: "index",
    path: "/",
    meta: { ...(indexkMZk66fnaWrDBBHzOozpdTwaCSYXfnb_9ujj9k9oJHQMeta || {}), ...{"middleware":["landing-page","home-landing-page"]} },
    component: () => import("/data/gitlab-runner/builds/vxUBjD1hN/0/spilnu/frontend/luxcasino-uk/app/pages/index.vue")
  },
  {
    name: component_45stubbKUvDcwxbcDjVydyStq59Yagf63MjYUiUDtJV_bsgFIMeta?.name,
    path: "/responsible-gambling",
    component: component_45stubbKUvDcwxbcDjVydyStq59Yagf63MjYUiUDtJV_bsgFI
  },
  {
    name: component_45stubbKUvDcwxbcDjVydyStq59Yagf63MjYUiUDtJV_bsgFIMeta?.name,
    path: "/bingo-me",
    component: component_45stubbKUvDcwxbcDjVydyStq59Yagf63MjYUiUDtJV_bsgFI
  },
  {
    name: component_45stubbKUvDcwxbcDjVydyStq59Yagf63MjYUiUDtJV_bsgFIMeta?.name,
    path: "/bonus-wheel",
    component: component_45stubbKUvDcwxbcDjVydyStq59Yagf63MjYUiUDtJV_bsgFI
  },
  {
    name: component_45stubbKUvDcwxbcDjVydyStq59Yagf63MjYUiUDtJV_bsgFIMeta?.name,
    path: "/promo-wheel",
    component: component_45stubbKUvDcwxbcDjVydyStq59Yagf63MjYUiUDtJV_bsgFI
  },
  {
    name: component_45stubbKUvDcwxbcDjVydyStq59Yagf63MjYUiUDtJV_bsgFIMeta?.name,
    path: "/ht-promo-wheel",
    component: component_45stubbKUvDcwxbcDjVydyStq59Yagf63MjYUiUDtJV_bsgFI
  }
]